import type { NodeParameters } from '../../../types/node-properties';

/**
 * Default parameter values for Brave Search node
 */
const defaults: NodeParameters = {
  credentialId: '',
  query: '',
  count: 10,
  country: 'US',
  safesearch: 'moderate',
  freshness: 'any',
  search_lang: 'en',
  offset: 0,
  spellcheck: true,
  text_decorations: true,
  result_filter: []
};

export default defaults;
